import _taggedTemplateLiteral from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _assertThisInitialized from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _getPrototypeOf from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/get";
import _createClass from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <style>\n      :host {\n        display: inline-block;\n      }\n    \n      :host ::slotted(*) {\n        padding: var(--wired-radio-group-item-padding, 5px);\n      }\n    </style>\n    <slot id=\"slot\" on-slotchange=\"", "\"></slot>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { LitElement, html } from '@polymer/lit-element/lit-element.js';
export var WiredRadioGroup =
/*#__PURE__*/
function (_LitElement) {
  _inherits(WiredRadioGroup, _LitElement);

  _createClass(WiredRadioGroup, [{
    key: "_render",
    value: function _render(_ref) {
      var _this2 = this;

      var selected = _ref.selected;
      return html(_templateObject(), function () {
        return _this2.slotChange();
      });
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        selected: String
      };
    }
  }]);

  function WiredRadioGroup() {
    var _this;

    _classCallCheck(this, WiredRadioGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WiredRadioGroup).call(this));
    _this._radioNodes = [];
    _this._checkListener = _this._handleChecked.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(WiredRadioGroup, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(WiredRadioGroup.prototype), "connectedCallback", this).call(this);

      this.addEventListener('change', this._checkListener);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      _get(_getPrototypeOf(WiredRadioGroup.prototype), "disconnectedCallback", this).call(this);

      this.removeEventListener('checked', this._checkListener);
    }
  }, {
    key: "_handleChecked",
    value: function _handleChecked(event) {
      var checked = event.detail.checked;
      var name = event.target.name;

      if (!checked) {
        event.target.checked = true;
      } else {
        this.selected = checked && name || '';

        this._fireSelected();
      }
    }
  }, {
    key: "_fireSelected",
    value: function _fireSelected() {
      var ce = new CustomEvent('selected', {
        bubbles: true,
        composed: true,
        checked: this.checked,
        detail: {
          selected: this.selected
        }
      });
      this.dispatchEvent(ce);
    }
  }, {
    key: "slotChange",
    value: function slotChange() {
      this.requestRender();
    }
  }, {
    key: "_didRender",
    value: function _didRender() {
      var slot = this.shadowRoot.getElementById('slot');
      var nodes = slot.assignedNodes();
      this._radioNodes = [];

      if (nodes && nodes.length) {
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].tagName === "WIRED-RADIO") {
            this._radioNodes.push(nodes[i]);

            var name = nodes[i].name || '';

            if (this.selected && name === this.selected) {
              nodes[i].checked = true;
            } else {
              nodes[i].checked = false;
            }
          }
        }
      }

      this.setAttribute('role', 'radiogroup');
      this.tabIndex = this.getAttribute('tabindex') || 0;

      this._attachEvents();
    }
  }, {
    key: "_attachEvents",
    value: function _attachEvents() {
      var _this3 = this;

      if (!this._keyboardAttached) {
        this.addEventListener('keydown', function (event) {
          switch (event.keyCode) {
            case 37:
            case 38:
              event.preventDefault();

              _this3._selectPrevious();

              break;

            case 39:
            case 40:
              event.preventDefault();

              _this3._selectNext();

              break;
          }
        });
        this._keyboardAttached = true;
      }
    }
  }, {
    key: "_selectPrevious",
    value: function _selectPrevious() {
      var list = this._radioNodes;

      if (list.length) {
        var radio = null;
        var index = -1;

        if (this.selected) {
          for (var i = 0; i < list.length; i++) {
            var n = list[i];

            if (n.name === this.selected) {
              index = i;
              break;
            }
          }

          if (index < 0) {
            radio = list[0];
          } else {
            index--;

            if (index < 0) {
              index = list.length - 1;
            }

            radio = list[index];
          }
        } else {
          radio = list[0];
        }

        if (radio) {
          radio.focus();
          this.selected = radio.name;

          this._fireSelected();
        }
      }
    }
  }, {
    key: "_selectNext",
    value: function _selectNext() {
      var list = this._radioNodes;

      if (list.length) {
        var radio = null;
        var index = -1;

        if (this.selected) {
          for (var i = 0; i < list.length; i++) {
            var n = list[i];

            if (n.name === this.selected) {
              index = i;
              break;
            }
          }

          if (index < 0) {
            radio = list[0];
          } else {
            index++;

            if (index >= list.length) {
              index = 0;
            }

            radio = list[index];
          }
        } else {
          radio = list[0];
        }

        if (radio) {
          radio.focus();
          this.selected = radio.name;

          this._fireSelected();
        }
      }
    }
  }]);

  return WiredRadioGroup;
}(LitElement);
customElements.define('wired-radio-group', WiredRadioGroup);